import React, { FC } from 'react';

import * as T from './interfaces';
import * as S from './styles';

export const Button: FC<T.IButton> = ({
  children,
  loading,
  icon,
  altIcon,
  ...rest
}) => (
  <S.Button {...rest} loading={loading ? 1 : 0}>
    {children}
    <div className="loader-icon">
      {loading && (
        <>
          <div className="loader" data-testid={`loader-${rest.id}`} />
        </>
      )}
    </div>
    {icon && <S.Icon src={icon} alt={altIcon || 'Ícone do Botão'} />}
  </S.Button>
);
/*
  Note:
    In the future a load component
    must be created to replace
    with this div.loader-icon
*/
